module.exports = __webpack_public_path__ + "img/g_xue.41b2dd1f.png";